export interface IDimensionsState {
	width: any;
	depth: any;
	wallHeight: any;
	buildingHeight: any;
	doorFrameHeightAdjust: number; // formerly `sizeErrorValue` in SeadevShedBuilder.
}

export interface IShedState {
	dimensions: IDimensionsState;
}

export function createInitialState(): IShedState {
	return {
		dimensions: {
			width: undefined,
			depth: undefined,
			wallHeight: undefined,
			buildingHeight: undefined,
			doorFrameHeightAdjust: 0,
		},
	};
}
